import { render, staticRenderFns } from "./notifyDetail.vue?vue&type=template&id=c6dde0ca&scoped=true&"
import script from "./notifyDetail.vue?vue&type=script&lang=js&"
export * from "./notifyDetail.vue?vue&type=script&lang=js&"
import style0 from "./notifyDetail.vue?vue&type=style&index=0&id=c6dde0ca&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dde0ca",
  null
  
)

export default component.exports